import React from "react";
import { useShallow } from "zustand/react/shallow";
import { ShippingMethod as ShippingMethodUI } from "@codway-dev/ui";
import { useEditorStore, ComponentSettings } from "../../../store";

/**
 * Canvas preview for the storefront shipping block — not the live widget.
 *
 * - Uses **useEditorStore** (`previewDeliveryMode`, config) so designers see tabs/options
 *   without touching cart, bootstrap rates, or `deliveryMode` / `setShipping` (those live in
 *   **theme-extension-widget** only).
 * - Dummy rates are intentional: the editor has no order totals or logistics API here.
 */
const DUMMY_OPTIONS = [
  {
    id: "standard",
    name: "Envío Estándar",
    description: "Entrega en 3-5 días hábiles",
    priceLabel: "$5.00",
  },
  {
    id: "express",
    name: "Express",
    description: "Entrega en 1-2 días hábiles",
    priceLabel: "$15.00",
  },
];

interface ShippingMethodPreviewProps {
  label?: string;
}

export const ShippingMethod: React.FC<ShippingMethodPreviewProps> = ({
  label,
}) => {
  const componentStyles = useEditorStore(
    useShallow(
      (state): NonNullable<ComponentSettings["shipping_method"]> =>
        state.config.design.settings.components?.shipping_method ?? {}
    )
  );
  const officesEnabled = useEditorStore(
    (state) => state.config.settings.offices?.enabled === true
  );

  const [selectedId, setSelectedId] = React.useState("standard");
  const deliveryMode = useEditorStore((state) => state.ui.previewDeliveryMode);
  const setPreviewDeliveryMode = useEditorStore(
    (state) => state.setPreviewDeliveryMode
  );
  const effectiveDeliveryMode = officesEnabled ? deliveryMode : "home";

  return (
    <div className="admin-shipping-method-preview">
      <ShippingMethodUI
        title={label}
        options={DUMMY_OPTIONS}
        selectedId={selectedId}
        onSelect={setSelectedId}
        officesEnabled={officesEnabled}
        deliveryMode={effectiveDeliveryMode}
        onDeliveryModeChange={setPreviewDeliveryMode}
        showRadioButton={componentStyles.show_radio_button ?? true}
        backgroundColor={componentStyles.background_color}
        activeBorderColor={componentStyles.active_border_color}
      />
    </div>
  );
};
